import { createSlice } from "@reduxjs/toolkit";

//Standard Default values

const viewportHeightStandardRatio = 1;
const viewportWidthStandardRatio = 1;

const sidebarWidthStandardRatio = 0.25;
const sidebarWidthMaxStandard = 350;
const sidebarWidthMinStandard = 325;

const footerHeightStandardRatio = 0.06;
const footerWidthStandardRatio = 0.99;
const footerHeightMinStandard = 100;
const footerHeightMaxStandard = 150;

const upperSidebarStandardHeight = 90;

const topOffset = 0;
const leftOffset = 0;
const bottomOffset = 0;
const panelGap = 5;

const menubarLeftOffset = 0;
const menubarTopOffset = 52;
const contentTopOffset = 50;

const rightToolBarRightOffset = 10;

const mapModalTopOffset = 50;
const mapModalOffset = 50;
const mapModalMinWidthStandard = 350;
const mapModalMaxWidthStandard = 450;
const mapModalMaxHeightStandard = 500;

const adminModalTopOffset = 50;
const adminModalOffset = 50;
const adminModalMinWidthStandard = 550;
const adminModalMaxWidthStandard = 900;
const adminModalMaxHeightStandard = 500;

const fuelAdminModalTopOffset = 50;
const fuelAdminModalOffset = 50;
const fuelAdminModalMinWidthStandard = 850;
const fuelAdminModalMaxWidthStandard = 1100;
const fuelAdminModalMaxHeightStandard = 700;

const eventBarTopHeightStandard = 120;
const eventBarPaginateHeightStandard = 50;
const trackViewTopHeightStandard = 85;
const subAccountTopHeightStandard = 112;
const subAccountListGapStandard = 10;

const assetEventListWidthStandard = 225;
const trackTimeLineWidthStandard = 350;

const trackPlayerHeightStandard = 50;

const placesTopHeightStandard = 130;
const tripsTopHeightStandard = 80;

export const layoutSlice = createSlice({
    name: 'layout',
    initialState: {
        liveTracking: {},
        eventTicker: false,
        currentPage: '/',
    },
    reducers: {
        setlayoutLiveTracking: (state, { payload }) => {
            //console.log("Layout reducer triggered", payload);
            state.liveTracking = liveTrackingLayout(payload);
            return state;
        },
        toggleEventTicker: (state) => {
            state.eventTicker = !state.eventTicker;
            return state;
        },
        setCurrentPage: (state, { payload }) => {
            state.currentPage = payload;
            return state;
        }
    }
})

export const { setlayoutLiveTracking, toggleEventTicker, setCurrentPage } = layoutSlice.actions;
export const liveTrackinglayoutSelector = state => state.layout.liveTracking;
export const eventTickerShowSelector = state => state.layout.eventTicker;

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
};

const liveTrackingLayout = (layoutobj) => {

    //console.log("Layout Obj", layoutobj);

    const sidebarWidthratio = layoutobj.sidebarWidthratio || sidebarWidthStandardRatio;
    const maxSidebar = layoutobj.maxSidebar || sidebarWidthMaxStandard;
    const minSideBar = layoutobj.minSideBar || sidebarWidthMinStandard;
    const footerHeightRatio = layoutobj.footerHeightRatio || footerHeightStandardRatio;
    const maxFooter = layoutobj.maxFooter || footerHeightMaxStandard;
    const minFooter = layoutobj.minFooter || footerHeightMinStandard;
    const viewportHeightRatio = layoutobj.viewportHeightRatio || viewportHeightStandardRatio;
    const viewportWidthRatio = layoutobj.viewportWidthRatio || viewportWidthStandardRatio;
    const footerWidthRatio = layoutobj.footerWidthRatio || footerWidthStandardRatio;
    const uppersidebarHeight = layoutobj.uppersidebarHeight || upperSidebarStandardHeight;
    const mapModalHeight = layoutobj.mapModalHeight || mapModalMaxHeightStandard;
    const subAccountTopHeight = layoutobj.subAccountTopHeight || subAccountTopHeightStandard;
    const subAccountListGap = layoutobj.subAccountListGap || subAccountListGapStandard;


    const { height, width } = getWindowDimensions();

    const mainWidth = viewportWidthRatio * width;
    const mainHeight = viewportHeightRatio * height - 48;
    const mainViewLeft = leftOffset;
    const mainViewTop = topOffset;
    const footerLeft = mainViewLeft + menubarLeftOffset + panelGap;
    const footerBottom = bottomOffset + panelGap;



    const footerWidth = mainWidth * footerWidthRatio;
    let footerHeight = Math.floor(footerHeightRatio * height);
    if (footerHeight < minFooter) {
        footerHeight = minFooter;
    }
    if (footerHeight > maxFooter) {
        footerHeight = maxFooter;
    }

    let sidebarWidth = Math.floor(sidebarWidthratio * mainWidth);
    if (sidebarWidth < minSideBar) {
        sidebarWidth = minSideBar;
    }
    if (sidebarWidth > maxSidebar) {
        sidebarWidth = maxSidebar;
    }

    let sidebarHeight = mainHeight - footerHeight - panelGap * 3 - footerBottom;
    let contentHeight = mainHeight - footerBottom;
    //let contentHeight = mainHeight - footerHeight - panelGap - footerBottom;
    const contentWidth = mainWidth - sidebarWidth - 13;


    const bodyTableLeft = mainViewLeft + menubarLeftOffset + panelGap;
    const bodyTableTop = mainViewTop + menubarTopOffset + panelGap;
    const bodyTableWidth = viewportWidthRatio * width - 10;
    const bodyTableHeight = viewportHeightRatio * height - 25;

    const sidebarLeft = mainViewLeft + menubarLeftOffset + panelGap;
    const sidebarTop = mainViewTop + menubarTopOffset + panelGap;


    const lowersidebarTop = sidebarTop + uppersidebarHeight + panelGap;
    const lowersidebarHeight = sidebarHeight - uppersidebarHeight - panelGap;

    const contentLeft = mainViewLeft + sidebarWidth + panelGap * 2;
    const contentTop = mainViewTop + contentTopOffset + panelGap;


    const rightToolbarTop = sidebarTop + 5;

    const mapModalTop = sidebarTop + mapModalTopOffset;
    const mapModalLeft = sidebarLeft + sidebarWidth + mapModalOffset;


    const adminModalTop = sidebarTop + adminModalTopOffset;
    const adminModalLeft = sidebarLeft + adminModalOffset;

    const eventCardWidth = sidebarWidth - 2 * panelGap;
    const eventCardHeight = footerHeight - panelGap;

    const eventFlashCardWidth = sidebarWidth;
    const eventFlashCardHeight = footerHeight - panelGap;

    const eventBarTopHeight = eventBarTopHeightStandard;
    const eventBarBottomTop = sidebarTop + eventBarTopHeight + panelGap;
    const eventBarPaginateHeight = eventBarPaginateHeightStandard;
    const eventBarBottomHeight = mainHeight - eventBarTopHeight - panelGap * 3 - footerBottom - eventBarPaginateHeight;
    const eventBarPaginateTop = eventBarBottomTop + eventBarBottomHeight + panelGap;

    const assetEventListTop = sidebarTop - 4;
    const assetEventListLeft = sidebarLeft + sidebarWidth + panelGap;
    const assetEventListWidth = assetEventListWidthStandard;
    const assetEventListHeight = sidebarHeight + 4;

    const trackViewTopHeight = trackViewTopHeightStandard;
    const trackViewBottomTop = sidebarTop + trackViewTopHeight + panelGap;
    const trackViewBottomHeight = mainHeight - trackViewTopHeight - panelGap * 3 - footerBottom;

    const trackTimeLineTop = sidebarTop;
    const trackTimeLineLeft = sidebarLeft + sidebarWidth + 2 * panelGap;
    const trackTimeLineWidth = trackTimeLineWidthStandard;
    const trackTimeLineHeight = sidebarHeight;

    const trackPlayerBottom = footerBottom;
    const trackPlayerLeft = sidebarLeft + sidebarWidth + 3 * panelGap + 40;
    const trackPlayerWidth = contentWidth - 80;
    const trackPlayerHeight = trackPlayerHeightStandard;

    const placesTopHeight = placesTopHeightStandard;
    const placesListViewTop = sidebarTop + placesTopHeight;
    const placesListViewHeight = mainHeight - placesTopHeight - panelGap * 2 - footerBottom - eventBarPaginateHeight;

    //placesTopHeight, placesListViewTop, placesListViewHeight
    const tripsTopHeight = tripsTopHeightStandard;
    const tripsListViewTop = sidebarTop + tripsTopHeight;
    const tripsListViewHeight = mainHeight - tripsTopHeight - panelGap * 2 - footerBottom - 5;

    const subAccountBarBottomTop = sidebarTop + subAccountTopHeight + subAccountListGap;
    const subAccountBarBottomHeight = Math.max(
        0,
        mainHeight - (subAccountBarBottomTop - mainViewTop)
    );
    const subAccountDetailTop = sidebarTop;
    const subAccountDetailHeight = Math.max(0, mainHeight - (subAccountDetailTop - mainViewTop));

    const layout = {
        main: {
            position: 'fixed !important',
            width: `${mainWidth}px`,
            height: `${mainHeight}px`,
            left: `${mainViewLeft}px`,
            top: `${mainViewTop}px`,
            overflowX: 'hidden',
            overflowY: 'hidden',
        },
        osm: {
            position: 'fixed',
            width: `${mainWidth}px`,
            height: `${mainHeight + 48}px`,
            left: `${mainViewLeft}px`,
            top: `${mainViewTop}px`,
            overflowX: 'hidden',
            overflowY: 'hidden',
        },
        bodyTable: {
            position: 'fixed',
            width: `${bodyTableWidth}px`,
            height: `${sidebarHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${lowersidebarTop}px`,
            overflowX: 'hidden',
            overflowY: 'hidden',
        },
        bodyHeader: {
            position: 'fixed',
            width: `${contentWidth}px`,
            height: `${uppersidebarHeight}px`,
            left: `${contentLeft}px`,
            top: `${sidebarTop - 5}px`,
        },
        sidebar: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${sidebarHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        uppersidebar: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${uppersidebarHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        lowersidebar: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${lowersidebarHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${lowersidebarTop}px`,
        },
        content: {
            position: 'fixed',
            width: `${contentWidth}px`,
            maxHeight: `${contentHeight}px`,
            height: `${contentHeight}px`,
            left: `${contentLeft}px`,
            top: `${contentTop}px`,
            widthpx: contentWidth - 50,
        },
        footer: {
            position: 'fixed',
            height: `${footerHeight}px`,
            width: `${footerWidth}px`,
            left: `${footerLeft}px`,
            bottom: `${footerBottom}px`
        },
        rightToolbar: {
            position: 'fixed',
            //width: `${rightToolbarWidth}px`,
            maxHeight: `${sidebarHeight}px`,
            right: `${rightToolBarRightOffset}px`,
            top: `${rightToolbarTop}px`,
        },
        mapModal: {
            position: 'fixed',
            top: `${mapModalTop}px`,
            left: `${mapModalLeft}px`,
            minWidth: `${mapModalMinWidthStandard}px`,
            maxWidth: `${mapModalMaxWidthStandard}px`,
            maxHeight: `${mapModalHeight}px`,
            overflow: 'auto'
        },
        adminModal: {
            position: 'fixed',
            top: `${adminModalTop}px`,
            left: `${adminModalLeft}px`,
            minWidth: `${adminModalMinWidthStandard}px`,
            width: `${adminModalMaxWidthStandard}px`,
            maxHeight: `${adminModalMaxHeightStandard}px`,
        },
        fuelAdminModal: {
            position: 'fixed',
            top: `${adminModalTop}px`,
            left: `${adminModalLeft}px`,
            minWidth: `${fuelAdminModalMinWidthStandard}px`,
            width: `${fuelAdminModalMaxWidthStandard}px`,
            maxHeight: `${fuelAdminModalMaxHeightStandard}px`,
            overflow: 'auto'
        },
        eventCard: {
            width: `${eventCardWidth}px`,
            maxHeight: `${eventCardHeight}px`,
        },
        eventFlashCard: {
            width: `${eventFlashCardWidth}px`,
            //maxHeight: `${eventFlashCardHeight}px`,
            height: `${eventFlashCardHeight}px`,
        },
        eventBarTop: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${eventBarTopHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        eventBarBottom: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${eventBarBottomHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${eventBarBottomTop}px`,
        },
        eventBarPaginate: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${eventBarPaginateHeight}px`,
            left: `${sidebarLeft}px`,
            //bottom: `${eventBarPaginateBottom}px`,
            top: `${eventBarPaginateTop}px`,
        },
        assetEventList: {
            position: 'fixed',
            width: `${assetEventListWidth}px`,
            maxHeight: `${assetEventListHeight}px`,
            left: `${assetEventListLeft}px`,
            top: `${assetEventListTop}px`,
            overflow: 'auto',
        },
        placesTop: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${placesTopHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        placesListView: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${placesListViewHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${placesListViewTop}px`,
        },
        trackViewTop: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${trackViewTopHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        trackViewBottom: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${trackViewBottomHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${trackViewBottomTop}px`,
        },
        reportDetailViewTop: {
            position: 'fixed',
            width: `${contentWidth}px`,
            height: `${trackViewTopHeight}px`,
            left: `${contentLeft}px`,
            top: `${sidebarTop - 3}px`,
        },
        reportDetailViewBottom: {
            position: 'fixed',
            width: `${contentWidth}px`,
            maxHeight: `${trackViewBottomHeight}px`,
            minHeight: `${trackViewBottomHeight}px`,
            left: `${contentLeft}px`,
            top: `${trackViewBottomTop}px`,
        },
        trackTimeLine: {
            position: 'fixed',
            width: `${trackTimeLineWidth}px`,
            maxHeight: `${trackTimeLineHeight}px`,
            left: `${trackTimeLineLeft}px`,
            top: `${trackTimeLineTop}px`,
            overflow: 'auto',
        },
        trackPlayer: {
            position: 'fixed',
            height: `${trackPlayerHeight}px`,
            width: `${trackPlayerWidth}px`,
            left: `${trackPlayerLeft}px`,
            bottom: `${trackPlayerBottom}px`
        },
        subAccountBarTop: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${subAccountTopHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        subAccountBarBottom: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${subAccountBarBottomHeight}px`,
            maxHeight: `${subAccountBarBottomHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${subAccountBarBottomTop}px`,
        },
        subAccountDetailView: {
            position: 'fixed',
            width: `${contentWidth}px`,
            height: `${subAccountDetailHeight}px`,
            maxHeight: `${subAccountDetailHeight}px`,
            minHeight: `${subAccountDetailHeight}px`,
            left: `${contentLeft}px`,
            top: `${subAccountDetailTop}px`,
        },
        googleRouterTop: {
            position: 'fixed',
            width: `${contentWidth - 50}px`,
            height: `${trackViewTopHeight - 50}px`,
            left: `${contentLeft}px`,
            top: `${sidebarTop - 10}px`,
        },

        tripsTop: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${tripsTopHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${sidebarTop}px`,
        },
        tripsListView: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${tripsListViewHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${tripsListViewTop}px`,
        },
        routesListView: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            maxHeight: `${tripsListViewHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${tripsListViewTop}px`,
        },
        routesBarPaginate: {
            position: 'fixed',
            width: `${sidebarWidth}px`,
            height: `${eventBarPaginateHeight}px`,
            left: `${sidebarLeft}px`,
            top: `${eventBarPaginateTop}px`,
        },

        tripReportView: {
            position: 'fixed',
            width: `${contentWidth - 250}px`,
            maxHeight: `${trackViewBottomHeight}px`,
            minHeight: `${trackViewBottomHeight}px`,
            left: `${contentLeft}px`,
            top: `${sidebarTop - 3}px`,
        },
    };

    //console.log("Layout from reducer", layout.eventBarPaginate);
    return layout;
};
